module.exports = __webpack_public_path__ + "img/table-view-help.dfbf3ee4.png";